import { Box, Grid } from '@chakra-ui/react';
import { Color } from 'src/theme/color';

export const RightColumn = ({ children }: any) => {
	return <Grid borderLeft={`1px solid ${Color.FROM_BORDER}`}>{children}</Grid>;
};
